import { composeIO } from 'react-compose-io'
import { novaAssociacaoIO } from './NovaAssociacao.IO'
import { NovaAssociacaoView } from './NovaAssociacao.View'

export const NovaAssociacao = composeIO(NovaAssociacaoView, novaAssociacaoIO)
